import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { motion } from 'framer-motion';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Banner } from './components/Banner';
import { LandingPage } from './pages/LandingPage';
import { HomePage } from './pages/Home';
import { ServicesPage } from './pages/ServicesPage';
import { WorkPage } from './pages/WorkPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
// Replace with your actual Google Tag Manager ID
const GTM_ID = 'GTM-XXXXXXX';
function GoogleTagManager() {
  const location = useLocation();
  useEffect(() => {
    // Load GTM script
    const script = document.createElement('script');
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${GTM_ID}');
    `;
    document.head.appendChild(script);
    // Add noscript iframe to body
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);
  // Track page views on route change
  useEffect(() => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'pageview',
        page: location.pathname + location.search
      });
    }
  }, [location]);
  return null;
}
export function AppRouter() {
  return <BrowserRouter data-id="element-1">
      <ThemeProvider data-id="element-2">
        <GoogleTagManager data-id="element-3" />
        <motion.div className="min-h-screen bg-background transition-colors duration-500" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5
      }} style={{
        paddingTop: 'var(--banner-height, 0px)'
      }} data-id="element-4">
          <Banner data-id="element-5" />
          <Header data-id="element-6" />
          <Routes data-id="element-7">
            <Route path="/" element={<LandingPage data-id="element-9" />} data-id="element-8" />
            <Route path="/home" element={<HomePage data-id="element-11" />} data-id="element-10" />
            <Route path="/services" element={<ServicesPage data-id="element-13" />} data-id="element-12" />
            <Route path="/work" element={<WorkPage data-id="element-15" />} data-id="element-14" />
            <Route path="/about" element={<AboutPage data-id="element-17" />} data-id="element-16" />
            <Route path="/contact" element={<ContactPage data-id="element-19" />} data-id="element-18" />
          </Routes>
          <Footer data-id="element-20" />
        </motion.div>
      </ThemeProvider>
    </BrowserRouter>;
}